<template>
  <div class="col-12 mt-3">
    <div class="equip-accordion">
      <div
        v-for="(group, index) in groups"
        :key="'standard_' + group.name"
        class="equip-accordion__row"
      >
        <button
          class="equip-accordion__header"
          type="button"
          @click="toggleGroup(index)"
          :aria-expanded="openGroups[index] ? 'true' : 'false'"
        >
          <span class="equip-accordion__title">{{ group.name || 'Egyéb' }}</span>
          <i :class="openGroups[index] ? 'fas fa-minus' : 'fas fa-plus'" class="equip-accordion__icon"></i>
        </button>
        <transition name="collapse-fade">
          <div v-show="openGroups[index]" class="equip-accordion__body">
            <div
              v-for="item in group.items"
              :key="'standard_' + item.name"
              class="row box-row"
            >
              <div class="col box-label d-flex justify-content-between">{{ item.name }}</div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import _ from 'lodash';
  import { Component, Prop } from 'vue-property-decorator';

  @Component
  export default class StandardEquipments extends Vue {
    @Prop(Object) standardEquipments;

    groups = [];
    openGroups = {};

    created() {
      const prepared = _.mapValues(this.standardEquipments, (value, index) => {
        return {
          items: [...value],
          name: index
        };
      });

      this.groups = _.values(prepared);
    }

    toggleGroup(index) {
      this.$set(this.openGroups, index, !this.openGroups[index]);
    }
  }
</script>

<style scoped>
.equip-accordion {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}
.equip-accordion__row {
  border-bottom: 1px solid #e5e7eb;
}
.equip-accordion__row:last-child {
  border-bottom: none;
}
.equip-accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease;
}
.equip-accordion__header:hover {
  background-color: #f9fafb;
}
.equip-accordion__title {
  font-weight: 700;
  color: #0b3b6b;
  font-size: 0.95rem;
}
.equip-accordion__icon {
  color: #0b3b6b;
  font-size: 0.85rem;
  flex-shrink: 0;
}
.equip-accordion__body {
  padding: 4px 16px 16px;
}
.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.3s, max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
  max-height: 0;
}
.collapse-fade-enter-to, .collapse-fade-leave {
  opacity: 1;
  max-height: 1000px;
}
</style>
